import Request from '@/utils/request'

// 9.99充值活动
export function apiWheelActCfg(activityType) {
  return Request({
    url: `/api/v2/app/shop/activity/${activityType}/cfg`,
    method: 'get',
  })
}

export function apiWheelActDraw(activityType) {
  return Request({
    url: `/api/v2/app/shop/activity/${activityType}/draw`,
    method: 'post',
  })
}
